import styled from 'styled-components';
import { useSelectedCollectedOrderDataValueContextHook } from '../../contexts/SelectedCollectedOrderDataContext';
import { useState } from 'react';

const StyledContainer = styled.div`
    padding: 10px;
`;

const StyledCardListWrapper = styled.div`
    display: flex;
    gap: 10px;
`;

const StyledCard = styled.div`
    width: 100%;
    background-color: #fff;
    padding: 10px;
    border-radius: 3px;
    border: 1px solid #e0e0e0;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .title{
        font-size: 16px;
        font-weight: 600;
    }
    
    .content{
        font-size: 16px;
    }

    &.cancel{
        border-color: var(--redColor1);
        color: var(--redColor1);
        cursor: pointer;
    }
`;
export function WegetCollectedSummary(props) {
    const selectedCollectedOrderDataValueContextHook = useSelectedCollectedOrderDataValueContextHook();
    const coupangApiStoreInfo = selectedCollectedOrderDataValueContextHook?.selectedCollectedOrderData?.coupangApiStoreInfo;
    const newOrders = selectedCollectedOrderDataValueContextHook?.selectedCollectedOrderData?.newOrders;
    const newCombinedOrders = selectedCollectedOrderDataValueContextHook?.selectedCollectedOrderData?.newCombinedOrders;

    const orderCountAggregation = getOrderCountAggregation({ newOrders: newOrders, newCombinedOrders: newCombinedOrders });

    return (
        <>
            <StyledContainer>
                <StyledCardListWrapper>
                    <StyledCard>
                        <div className='title'>스토어명</div>
                        <div className='content'>{coupangApiStoreInfo?.storeName}</div>
                    </StyledCard>
                    <StyledCard>
                        <div className='title'>총 신규주문 <span style={{ fontSize: '12px', color: '#666' }}>(주문건)</span></div>
                        <div className='content'>{orderCountAggregation?.totalCount} 건 <span style={{ fontSize: '12px', color: '#666' }}>({orderCountAggregation?.combinedTotalCount})</span></div>
                    </StyledCard>
                    <StyledCard>
                        <div className='title'>신규주문 <span style={{ fontSize: '12px', color: '#666' }}>(주문건)</span></div>
                        <div className='content'>{orderCountAggregation?.accept} 건 <span style={{ fontSize: '12px', color: '#666' }}>({orderCountAggregation?.combinedAccept})</span></div>
                    </StyledCard>
                    <StyledCard>
                        <div className='title'>상품준비중 <span style={{ fontSize: '12px', color: '#666' }}>(주문건)</span></div>
                        <div className='content'>{orderCountAggregation?.instruct} 건 <span style={{ fontSize: '12px', color: '#666' }}>({orderCountAggregation?.combinedInstruct})</span></div>
                    </StyledCard>
                </StyledCardListWrapper>
            </StyledContainer>

        </>
    );
}

function getOrderCountAggregation({ newOrders, newCombinedOrders }) {
    const instructCount = newOrders?.filter(order => order?.status === 'INSTRUCT')?.length;
    const acceptCount = newOrders?.filter(order => order?.status === 'ACCEPT')?.length;

    const combinedInstructCount = newCombinedOrders?.filter(order => order?.status === 'INSTRUCT')?.length;
    const combinedAcceptCount = newCombinedOrders?.filter(order => order?.status === 'ACCEPT')?.length;

    return {
        totalCount: newOrders?.length,
        instruct: instructCount,
        accept: acceptCount,
        combinedTotalCount: newCombinedOrders?.length,
        combinedInstruct: combinedInstructCount,
        combinedAccept: combinedAcceptCount
    }
}